import {
  Create,
  Datagrid,
  Edit,
  List,
  SaveButton,
  SimpleForm,
  TextField,
  Toolbar,
  EditButton,
  DateField,
  BooleanField,
  NullableBooleanInput,
  AutocompleteInput,
  ReferenceInput,
  FunctionField,
  TextInput,
  SelectInput,
  PasswordInput,
} from "react-admin";

export const AdminsList = (props) => {
  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="name" />
        <TextField source="username" />
        <TextField source="phonenumber" />
        <TextField source="role" />
        <FunctionField
          label="Created At"
          render={(record) =>
            `${new Date(record.created_at).toLocaleString()} `
          }
        />

        <EditButton></EditButton>
      </Datagrid>
    </List>
  );
};

export const AdminsCreate = (props) => {
  return (
    <Create title="Create a Sub-Category " {...props} redirect="list">
      <SimpleForm>
        <TextInput source="name" />
        <TextInput source="username" />
        <TextInput source="phonenumber" />
        <SelectInput
          source="role"
          choices={[
            { id: "admin", name: "Admin" },
            { id: "manager", name: "Manager" },
            { id: "operater", name: "Operater" },
            { id: "knowledgeManger", name: "KnowledgeManger" },
            { id: "supervisor", name: "Supervisor" },
          ]}
        />
        <PasswordInput source="password" initiallyVisible />
      </SimpleForm>
    </Create>
  );
};

const UserEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);
export const AdminsEdit = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm toolbar={<UserEditToolbar />}>
        <TextInput source="name" />
        <TextInput source="username" />
        <TextInput source="phonenumber" />
        <SelectInput
          source="role"
          choices={[
            { id: "admin", name: "Admin" },
            { id: "manager", name: "Manager" },
            { id: "operater", name: "Operater" },
            { id: "knowledgeManger", name: "KnowledgeManger" },
            { id: "supervisor", name: "Supervisor" },
          ]}
        />
      </SimpleForm>
    </Edit>
  );
};
